var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsBoolean, IsEnum, IsIn, IsNumber, IsOptional, IsPositive, IsString, MaxLength, } from 'class-validator';
import { PetType } from '../../../enums';
export class UpdatePreReservationDto {
    constructor(dto = {}) {
        this.customerName = dto.customerName;
        this.customerPhoneNumber = dto.customerPhoneNumber;
        this.customerEmail = dto.customerEmail;
        this.petType = dto.petType;
        this.petCount = dto.petCount;
        this.petTotalWeightKg = dto.petTotalWeightKg;
        this.petBreed = dto.petBreed;
        this.petPolicyAgreed = dto.petPolicyAgreed;
    }
}
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], UpdatePreReservationDto.prototype, "customerName", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], UpdatePreReservationDto.prototype, "customerPhoneNumber", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], UpdatePreReservationDto.prototype, "customerEmail", void 0);
__decorate([
    IsOptional(),
    IsEnum(PetType),
    __metadata("design:type", String)
], UpdatePreReservationDto.prototype, "petType", void 0);
__decorate([
    IsOptional(),
    IsIn([1, 2]),
    __metadata("design:type", Number)
], UpdatePreReservationDto.prototype, "petCount", void 0);
__decorate([
    IsOptional(),
    IsNumber(),
    IsPositive(),
    __metadata("design:type", Number)
], UpdatePreReservationDto.prototype, "petTotalWeightKg", void 0);
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(50),
    __metadata("design:type", String)
], UpdatePreReservationDto.prototype, "petBreed", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UpdatePreReservationDto.prototype, "petPolicyAgreed", void 0);
